import { Modal } from "antd";
import React from "react";
import Input from "../../../components/input";
import { Controller, useForm } from "react-hook-form";
import Button from "../../../components/button";
import useRequest from "../../../components/hooks/use-request";
import { showToast } from "../../../components/toast";
import { CircleLoader } from "react-spinners";

const CreateRole = ({ visible, handleClose }: any) => {
  const userToken = localStorage.getItem("token");
  const { loading, makeRequest } = useRequest("/roles", "POST", {
    userToken
  });
  const {
    handleSubmit,
    control,
    reset,
  } = useForm();

  const handleCreatePrivilege = handleSubmit(async (formData) => {
    const mediator = {
      name: formData.name,

    };
    const [response] = await makeRequest(mediator);
    if (response.status) {
      showToast(response.message, true, {
        position: "top-center",
      });
      reset()
      setTimeout(() => {
        window.location.reload()
      },3000 );
    } else {
      showToast(response.message, false, {
        position: "top-center",
      });
    }
  });

  return (
    <>
      <Modal
        visible={visible}
        onCancel={handleClose}
        width={790}
        closable={true}
        footer={null}
        className="flex justify-center items-center mt-14 px-10"
      >
        <h1 className="font-bold text-left text-[#040821] text-[18px]">
          Create New Role
        </h1>

        <form className="w-full mt-10" onSubmit={handleCreatePrivilege}>
          <div className= " w-[300px] mx-auto">
            <Controller
              name="name"
              control={control}
              defaultValue={""}
              rules={{
                required: "Role name is required",
                minLength: {
                  value: 3,
                  message: "Mediator must be at least 3 characters",
                },
              }}
              render={({ field, fieldState }) => (
                <Input
                  value={field.value}
                  label="Role Name"
                  className="w-full"
                  error={fieldState?.error?.message}
                  onChange={field.onChange}
                />
              )}
            />
          </div>

          <div className="flex gap-8 justify-center items-center mt-8">
            <Button size="md" variant="primary" type="submit">
            {loading ? (
              <CircleLoader color="#ffffff" loading={loading} size={20} />
            ) : (
              "Create New Role"
            )}
          </Button>
          </div>
        </form>
      </Modal>
    </>
  );
};

export default CreateRole;
